import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { CurrentUser } from './core/models/currentuser.models';
import { Subscription, fromEvent, merge, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { RootReducerState } from './store';
import { Store } from '@ngrx/store';
import { changeTheme } from './store/layouts/layout-action';
import { getTheme } from './store/layouts/layout-selector';
import { GenericService } from './core/services/generic.service';
import { AuthenticationService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = environment.vendorname;

  networkStatus: any;
  networkStatus$: Subscription = Subscription.EMPTY;

  currentuser!: CurrentUser

  isUnderMaintenance = false;

  constructor(private router: Router, private afs: AngularFirestore, 
    private store: Store<RootReducerState>, private genericService: GenericService, private authenticationService: AuthenticationService
    ) {
  }

  ngOnInit(): void {
    console.log("environment theme", environment.theme);
    this.changelayoutTheme(environment.theme);
    this.checkNetworkStatus();
    this.genericService.initialisesentry();
    this.getVendorGuidFromFirebase();
    this.checkMaintenanceStatus();
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }
  }

  // Theme Change
  changelayoutTheme(theme: string) {
    this.store.dispatch(changeTheme({ theme }));
    this.store.select(getTheme).subscribe((theme) => {
      document.documentElement.setAttribute('data-theme', theme)
    })
  }

  checkNetworkStatus() {
    this.networkStatus = navigator.onLine;
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    )
      .pipe(map(() => navigator.onLine))
      .subscribe(status => {
        this.networkStatus = status;
        if (!status) {
          document.getElementById('internettoast')?.classList.remove('d-none');
          document.getElementById('internettoast')?.classList.add('d-block');
        } else {
          document.getElementById('internettoast')?.classList.add('d-none');
          document.getElementById('internettoast')?.classList.remove('d-block');
        }
      });
  }

  getVendorGuidFromFirebase() {
    //FIND CURRENT SUBDOMAIN
    var domainurl = window.location.host;
    console.log('domain url', domainurl);
    this.afs.collection("subdomains").doc(domainurl).get().subscribe((result: any) => {
      console.log('firebase result', result.data());
      if (result.data()) {
        // console.log("result.data().guid", result.data().guid);
        sessionStorage.setItem("vendorguid", result.data().guid);
      }
    });
  }

  checkMaintenanceStatus() {
    let domainurl = window.location.host;
    this.afs.collection("subdomains").doc(domainurl).valueChanges().subscribe((result: any) => {
      if (result) {
        if (result.maintenance == true) {
          this.isUnderMaintenance = true;
          this.router.navigate(['/maintenance']);
        }
        else if (result.maintenance == false && this.isUnderMaintenance == true) {
          this.isUnderMaintenance = false;
          this.authenticationService.logout();
          this.router.navigate(['/auth/login']);
        }
      }
    });
  }
}
